<template>
  <div class="card overflow-hidden">
    <div class="bg-primary bg-soft">
      <div class="row">
        <div class="col-7 mb-4">
          <div class="text-primary p-3">
            <h5
              class="text-primary font-weight-bold"
              style="font-size: 14px; margin-bottom: 0.5rem"
            >
              Welcome Back !
            </h5>
            <p class="text-primary">Seller SIPlah</p>
          </div>
        </div>
        <div class="col-5 align-self-end">
          <img
            src="https://themesbrand.com/skote/layouts/assets/images/profile-img.png"
            alt=""
            class="img-fluid"
          />
        </div>
      </div>
    </div>
    <div class="card-body pt-0">
      <div class="row">
        <div class="col-sm-4">
          <div
            class="avatar-md profile-user-wid mb-4"
            style="margin-top: -28px"
          >
            <div class="img-cont" :style="profilePictureStyle"></div>
          </div>
          <h5 class="text-truncate" style="font-size: 15px">{{ user.name }}</h5>
          <p class="text-white mb-0 text-truncate badge badge-secondary">
            Seller
          </p>
        </div>

        <div class="col-sm-8">
          <div class="pt-4">
            <div class="row">
              <div class="col-6">
                <h5 class="font-size-15">{{ user.totalProduct }}</h5>
                <p class="text-muted mb-0">Produk Aktif</p>
              </div>
              <div class="col-6">
                <h5 class="font-size-15">{{ newOrderTotal }}</h5>
                <p class="text-muted mb-0">Pesanan Baru</p>
              </div>
            </div>
            <div class="mt-4">
              <router-link
                :to="'/profile'"
                class="btn btn-primary waves-effect waves-light btn-sm"
                >View Profile
                <i
                  class="fas fa-arrow-right ml-1 mr-1 pt-2 pb-2"
                  style="font-size: 8px"
                  aria-hidden="true"
                ></i
              ></router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="card" v-if="listUser.length != 0">
        <div class="card-header">
          <h5 class="card-title">{{ listUser.length }} User</h5>
        </div>
        <div class="card-body">
          <template v-for="(lu, index) in listUser">
            <div class="row mb-3" :key="index">
              <router-link :to="'/userlog/user/' + lu.nama" class="col">
                {{ lu.nama }}</router-link
              >
              <div class="col mb-2 text-success">{{ lu.email }}</div>
            </div>
          </template>
        </div>
      </div>
      <div class="card-chart mb-3" v-else>
        <div class="card-header">
          <h5 class="card-title mb-3">User</h5>
        </div>
        <div class="card-body rounded text-center bg-soft-secondary">
          <span>Belum ada user</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
// import $ from "jquery";
export default {
  data() {
    return {
      newOrderTotal: [],
      listUser: [],
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "isLoggedIn",
      user: "user",
    }),
    profilePictureStyle: function() {
      var bgImg = this.user.image.primary;
      return {
        width: "80px",
        height: "80px",
        "border-radius": "50%",
        background: "url(" + bgImg + ") no-repeat center center",
        "background-size": "contain",
        margin: "0 auto",
        "background-color": "white",
      };
    },
  },
  created() {
    this.attrDashboard();
    this.getUser();
  },
  methods: {
    getUser() {
      fetch(`/backendseller/registration_api/list_user?mall_id=${this.user.id}`)
        .then((response) => response.json())
        .then((data) => {
          this.listUser = data;
        });
    },
    attrDashboard() {
      let dashboardUrl = "seller/dashboard";
      axios
        .get(dashboardUrl)
        .then((response) => {
          this.forPlaceholder = response.data.data;
          return response;
        })
        // .then(sleeper(800))
        .then((response) => {
          // console.log(response.data.data)
          return response.data.data;
        })
        .then((data) => {
          this.newOrderTotal = data.card[0].total;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
